module.exports = __webpack_public_path__ + "img/pazzino.fce72538.png";